// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2IIbL","content":"LayoutSettings_content__NFxZP"};